var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup68128(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_148244",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_68128",
    "data-name": "Group 68128",
    transform: "translate(-1623 -175)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1623, 175)",
    filter: "url(#Rectangle_148244)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148244-2",
    "data-name": "Rectangle 148244",
    width: 46,
    height: 46,
    rx: 10,
    transform: "translate(9 7)",
    fill: "#0267c1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "share",
    transform: "translate(1646 194.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44875",
    "data-name": "Path 44875",
    d: "M15.059,14.451a2.778,2.778,0,0,1,2.071.871,2.954,2.954,0,0,1,0,4.141,2.9,2.9,0,0,1-4.141,0,2.9,2.9,0,0,1-.847-2.094,5.4,5.4,0,0,1,.047-.659L5.082,12.569a3.011,3.011,0,0,1-2.071.8A2.91,2.91,0,0,1,.871,12.5,2.91,2.91,0,0,1,0,10.357,2.91,2.91,0,0,1,.871,8.216a2.91,2.91,0,0,1,2.141-.871,3.011,3.011,0,0,1,2.071.8l7.059-4.094a3.368,3.368,0,0,1-.094-.706A2.91,2.91,0,0,1,12.918,1.2a3.068,3.068,0,0,1,4.282,0,2.882,2.882,0,0,1,.871,2.118A2.961,2.961,0,0,1,17.2,5.463a2.872,2.872,0,0,1-2.141.894,2.92,2.92,0,0,1-2.071-.847L5.929,9.651a3.368,3.368,0,0,1,.094.706,3.368,3.368,0,0,1-.094.706L13.082,15.2A2.882,2.882,0,0,1,15.059,14.451Z",
    transform: "translate(0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup68128);
export default __webpack_public_path__ + "static/media/Group 68128.95050a995d48cdb80d455049a4e195f2.svg";
export { ForwardRef as ReactComponent };